
import Checklist from 'vux/src/components/checklist/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: "filingorder",
components: {Group, XInput, XButton, Checklist, Confirm},
directives: {TransferDom},
data() {
return {
orderDetail: this.$route.query.order,
isReadonly: true,
devtypeshow: false,
checklist001: [],
quoteLine: [],
closed: this.$route.query.closed,
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
}
},
methods: {
choseDevtype() {
if (this.isReadonly) {
return
}
this.checklist001 = this.orderDetail.devtype.split(',')
this.devtypeshow = true;
},
sureDevtype() {
this.orderDetail.devtype = this.checklist001.join(',')
},
deleteOrder() {
const that = this
this.$vux.confirm.show({
content: '确认删除此订单',
theme: 'android',
onCancel() {

},
onConfirm() {
that.$http.get('/api/v1/srvp_projects/' + that.orderDetail.seq + '/remove_my_project?role=INDV', that.header).then(() => {
alert('删除成功');
that.$router.push({name: 'filinglist'})
}).catch(error => {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
}
})
},
saveOrder() {
this.$http.put('/api/v1/srvp_projects/' + this.orderDetail.seq + '/update_my_project', {
role: 'INDV',
info: {
customer: this.orderDetail.customer,
devtype: this.orderDetail.devtype,
agent: this.orderDetail.agent,
company: '北京中广上洋科技股份有限公司'
},
}, this.header).then(() => {
alert('修改备案成功');
this.$router.push({name: 'filinglist'})
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
}
},
created() {
this.$http.get('api/v1/srvp_products/user_list_cats?company=北京中广上洋科技股份有限公司&hint=').then((response) => {
this.quoteLine = response.data
})
}
}



// WEBPACK FOOTER //
// ./src/components/srvpproject/filingorder.vue